import { defineAsyncComponent } from 'vue';
import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-skyblue.min.css';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const DappCategories = defineAsyncComponent(() => import('@/js/dapps/DappCategories.vue'));
const DefiDappChart = defineAsyncComponent(() => import('@/js/dapps/DefiDappChart.vue'));
const LatestNewsAndVideos = defineAsyncComponent(() => import('@/js/global/widgets/LatestNewsAndVideos.vue'));

app.use(VueSplide);

app.component('DappCategories', DappCategories);
app.component('DefiDappChart', DefiDappChart);
app.component('LatestNewsAndVideos', LatestNewsAndVideos);

mountApp();
